import React from 'react';

const venues = [
  { name: 'Greenwoods', style: 'font-serif italic' },
  { name: 'Crondon Park', style: 'font-serif tracking-wide' },
  { name: 'Friern Manor', sub: 'Country House', style: 'font-serif tracking-wider' },
  { name: 'Hatfield Place', style: 'tracking-[0.2em] uppercase text-xs' },
  { name: 'Gaynes Park', style: 'font-serif' },
  { name: 'Channels', sub: 'Retreat', style: 'tracking-[0.3em] uppercase text-xs' },
  { name: 'The Warren Estate', style: 'font-serif italic tracking-wide' },
  { name: 'Parklands', sub: 'Quendon Hall', style: 'tracking-[0.15em] uppercase text-xs' },
  { name: 'Fennes', style: 'font-serif text-lg tracking-wide' },
  { name: 'Vaulty Manor', style: 'font-serif italic' },
  { name: 'Hutton Hall', style: 'tracking-[0.2em] uppercase text-xs' },
  { name: 'Wivenhoe House', style: 'font-serif tracking-wide' },
  { name: 'Apton Hall', sub: 'Wedding & Events', style: 'font-serif' },
  { name: 'Braxted Park', style: 'tracking-[0.2em] uppercase text-xs' },
  { name: 'High House', sub: 'Weddings', style: 'font-serif tracking-wide' },
  { name: 'Maidens Barn', style: 'font-serif text-lg' },
  { name: 'Mulberry House', style: 'font-serif italic tracking-wide' },
  { name: 'Ingrebourne Links', style: 'tracking-[0.15em] uppercase text-xs' },
  { name: 'East Mersea Hall', style: 'font-serif' },
  { name: 'Downham Hall', style: 'tracking-[0.2em] uppercase text-xs' },
  { name: 'Little Channels', style: 'font-serif italic' },
  { name: 'Prested Hall', style: 'tracking-[0.25em] uppercase text-xs' },
  { name: 'The Heron', sub: 'Country Club', style: 'font-serif tracking-wide' },
  { name: 'That Amazing Place', style: 'font-serif italic' },
  { name: 'Warley Park', style: 'tracking-[0.2em] uppercase text-xs' },
  { name: 'Stock Brook Manor', style: 'font-serif tracking-wide' },
  { name: 'Swynford Manor', style: 'font-serif italic' },
  { name: 'St Osyth Priory', style: 'font-serif' },
];

const VenueCard = ({ venue }) => (
  <div className="flex-shrink-0 flex flex-col items-center justify-center px-6 h-16">
    <span className={`text-gray-700 whitespace-nowrap leading-tight ${venue.style}`}>
      {venue.name}
    </span>
    {venue.sub && (
      <span className="text-gray-400 text-[10px] uppercase tracking-widest mt-0.5">{venue.sub}</span>
    )}
  </div>
);

const VenueStrip = () => {
  return (
    <section data-testid="venue-strip" className="bg-white py-8 overflow-hidden max-w-[100vw]">
      <p className="text-gray-400 text-xs font-semibold uppercase tracking-widest text-center mb-6">
        Recommended by
      </p>
      <div className="relative overflow-hidden w-full">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-10" />

        <div className="flex animate-scroll-x">
          {/* Two copies for seamless loop */}
          {[0, 1].map((copy) => (
            <div key={copy} className="flex items-center">
              {venues.map((venue, i) => (
                <React.Fragment key={`${copy}-${i}`}>
                  <VenueCard venue={venue} />
                  <div className="w-px h-6 bg-gray-200 flex-shrink-0 mx-2" />
                </React.Fragment>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VenueStrip;
